import { combineReducers } from 'redux'

import * as ActionTypes from './actionTypes'

export const NAME = 'aiLayer'

const byId = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      let byId = {}
      action.layers.forEach(layer => (byId[layer.id] = layer))
      return byId
    case ActionTypes.FETCH_START:
      return {}
    default:
      return state
  }
}

const allKeys = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.FETCH_START:
      return []
    case ActionTypes.FETCH_SUCCESS:
      return action.layers.map(layer => layer.id)
    default:
      return state
  }
}

const aiLayers = combineReducers({
  byId,
  allKeys
})

export default aiLayers
